module.exports = __webpack_public_path__ + "static/img/IMG_20241028_164653.a7b03a5d.jpg";